import { RegistrationAnswerModel } from '../../models/questions/registration-answer-model';

/** Answer model of question of user */
export class UserQuestionAnswerModel {
  constructor(body: RegistrationAnswerModel, clubId: number, portalId?: string) {
    this.QuestionId = body.QuestionId;
    this.AnswerId = body?.Id;
    this.AnswerValue = body.Answer;
    this.Selected = body.Selected;
    this.AnswerDate = new Date().toISOString();
    this.ClubId = clubId;
    this.PortalId = portalId;
  }
  /**Id of Answer */
  Id: number;
  /**Protal id of the current user  */
  PortalId: string | undefined;
  /**Id of question that answer place in */
  QuestionId: number;
  /**IDs of the answers */
  AnswerId: number;
  /**Value of Answer */
  AnswerValue: string;
  /**The date when user answered the question */
  AnswerDate: Date | string;
  /**ClubId of the current user */
  ClubId: number;
  /**Status of a answer */
  Selected: boolean;
}
